import React, { useEffect, useRef, useState } from "react";

import {
  ITimespan,
  ITimespanProps,
} from "components/dashboard/product-template-table/utils/interfaces";
import { convertTimeSpanToString } from "utils/time-utils";
import "./style.css";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { T } from "services/lang/LanguageService";

// eslint-disable-next-line import/prefer-default-export
export function Timespan(props: ITimespanProps) {
  const [currentTimeSpan, setCurrentTimeSpan] = useState<ITimespan>(props.timespan || {});
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const timespan = props.timespan || {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  const handleChangeEvent = (e: React.ChangeEvent<HTMLInputElement>, field: keyof ITimespan) => {
    const val = Number(e.target.value);
    setCurrentTimeSpan({ ...timespan, [field]: Number.isNaN(val) ? 0 : val });
  };

  const timespanValuesCount = () => Object.values(timespan).length;

  const divRef = useRef<HTMLDivElement>(null);
  const [style, setStyle] = useState({});

  const inputStyle = (inputWidth: number) => {
    return {
      width: `${inputWidth / timespanValuesCount()}px`,
      padding: "0",
    };
  };

  useEffect(() => {
    if (divRef.current !== null) {
      const width = divRef.current.offsetWidth;
      const styles = inputStyle(width);
      setStyle(styles);
    }
  }, [props.isInEditMode]);

  const inputStyle2 = { border: "none", width: "100%", padding: "5px" };

  const handleSaveTimeSpan = () => {
    props.changeHandler(currentTimeSpan);
    setIsDialogVisible(false);
  };

  const handleCloseDialog = () => {
    setCurrentTimeSpan(props.timespan || {});
    setIsDialogVisible(false);
  };

  const footerTemplate = () => (
    <div className="flex justify-content-end gap-2 mt-3">
      <Button
        label={T("action.cancel")}
        icon="pi pi-times"
        className="component-editor-button icon-red"
        onClick={handleCloseDialog}
      />
      <Button
        label={T("action.save")}
        icon="pi pi-check"
        className="component-editor-button icon-green"
        onClick={handleSaveTimeSpan}
      />
    </div>
  );

  if (props.isInEditMode) {
    return (
      <>
        <Button
          label={convertTimeSpanToString(timespan)}
          className="bg-gray-300 border-none text-black-alpha-90 hover:bg-gray-400 hover:text-white h-2rem"
          onClick={() => setIsDialogVisible(true)}
        />
        <Dialog
          header={T("header.timespan")}
          footer={footerTemplate}
          visible={isDialogVisible}
          style={{ width: "15vw" }}
          onHide={() => setIsDialogVisible(false)}
        >
          <div ref={divRef} className="p-d-flex p-jc-between h-3rem">
            <div
              className="p-inputtext p-d-flex p-jc-between align-items-center h-3rem"
              style={style}
            >
              <input
                className="p-inputtext input"
                style={inputStyle2}
                value={currentTimeSpan.days}
                onChange={e => handleChangeEvent(e, "days")}
                inputMode="numeric"
              />
              <label style={{ paddingBottom: "12px", paddingTop: "12px", paddingRight: "2px" }}>
                d
              </label>
            </div>
            <div
              className="p-inputtext p-d-flex p-jc-between align-items-center h-3rem"
              style={style}
            >
              <input
                className="p-inputtext input"
                style={inputStyle2}
                value={currentTimeSpan.hours}
                onChange={e => handleChangeEvent(e, "hours")}
                inputMode="numeric"
              />
              <label style={{ paddingBottom: "12px", paddingTop: "12px", paddingRight: "2px" }}>
                h
              </label>
            </div>
            <div
              className="p-inputtext p-d-flex p-jc-between align-items-center h-3rem"
              style={style}
            >
              <input
                className="p-inputtext input"
                style={inputStyle2}
                value={currentTimeSpan.minutes}
                onChange={e => handleChangeEvent(e, "minutes")}
                inputMode="numeric"
              />
              <label style={{ paddingBottom: "12px", paddingTop: "12px", paddingRight: "2px" }}>
                m
              </label>
            </div>
            <div
              className="p-inputtext p-d-flex p-jc-between align-items-center h-3rem"
              style={style}
            >
              <input
                className="p-inputtext input"
                style={inputStyle2}
                value={currentTimeSpan.seconds}
                onChange={e => handleChangeEvent(e, "seconds")}
                inputMode="numeric"
              />
              <label style={{ paddingBottom: "12px", paddingTop: "12px", paddingRight: "2px" }}>
                s
              </label>
            </div>
          </div>
        </Dialog>
      </>
    );
  }
  return (
    <div
      style={{
        width: "100%",
        border: "none",
        backgroundColor: "transparent",
        color: "inherit",
        whiteSpace: "nowrap",
      }}
      className="p-inputtext"
    >
      {convertTimeSpanToString(timespan)}
    </div>
  );
}
